/* Offer box motion (presentation only): the offer box pops twice, then one light sweep runs over the visible add-to-cart button. */
(function () {
  'use strict';
  if (window.__riwiOfferMotion) return;
  window.__riwiOfferMotion = 1;

  var BOX_SEL = '.f12-inner--black[data-bm-on][data-f12-on]';
  var DESKTOP_MQ = '(min-width: 901px)';
  var SCALE = 1.08;                       /* pop strength 8 % */
  var T = { DWELL: 450, POLL: 100, P1: 420, PAUSE: 120, P2: 380, P2_K: 0.8, GAP_D: 100, GAP_M: 150,
            SHINE_D: 600, SHINE_M: 1000, FAILSAFE: 25000 };
  var E_OUT = 'cubic-bezier(.2,.8,.3,1)', E_IO = 'ease-in-out', E_SHINE = 'cubic-bezier(.65,0,.35,1)';
  var CSS = '.rom-shine-clip{position:absolute;top:0;right:0;bottom:0;left:0;overflow:hidden;border-radius:inherit;pointer-events:none;opacity:.4}' +
    '.rom-shine{position:absolute;top:0;bottom:0;left:0;width:30%;pointer-events:none;border-radius:inherit;opacity:0;mix-blend-mode:screen;' +
    'background:linear-gradient(90deg,rgba(255,214,102,0),rgba(255,236,160,.85) 45%,rgba(255,255,235,.95) 50%,rgba(255,236,160,.85) 55%,rgba(255,214,102,0))}' +
    '@media (prefers-reduced-motion:reduce){.rom-shine-clip{display:none}}';
  var TOP_OVERLAYS = '.shopify-section-header-sticky:not(.shopify-section-header-hidden), sticky-header, [data-sticky-header]';
  var BOTTOM_OVERLAYS = '[data-sticky-atc].is-visible, #shopify-pc__banner';

  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var now = function () { return (window.performance && performance.now) ? performance.now() : Date.now(); };

  function storeKey() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return 'rom:' + (m ? m[1] : location.pathname);
  }
  function seen() { try { return !!sessionStorage.getItem(storeKey()); } catch (e) { return false; } }
  function markSeen() { try { sessionStorage.setItem(storeKey(), '1'); } catch (e) {} }

  function addCss() {
    if (document.getElementById('rom-css')) return;
    var s = document.createElement('style');
    s.id = 'rom-css'; s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* Box incl. overhanging motif */
  function outer(box) {
    var r = box.getBoundingClientRect(), u = { top: r.top, bottom: r.bottom, left: r.left, right: r.right, height: r.height };
    var kids = box.querySelectorAll('.f12-motif');
    for (var i = 0; i < kids.length; i++) {
      var q = kids[i].getBoundingClientRect();
      if (q.width <= 0 || q.height <= 0) continue;
      u.top = Math.min(u.top, q.top); u.bottom = Math.max(u.bottom, q.bottom);
      u.left = Math.min(u.left, q.left); u.right = Math.max(u.right, q.right);
    }
    return u;
  }

  /* Visible area = viewport minus fixed overlays (sticky header, sticky buy bar, cookie banner).
     A target inside an overlay is not measured against that overlay. */
  function insets(el) {
    var top = 0, bot = 0, i, n, r, cs, vh = window.innerHeight;
    n = document.querySelectorAll(TOP_OVERLAYS);
    for (i = 0; i < n.length; i++) {
      r = n[i].getBoundingClientRect(); cs = getComputedStyle(n[i]);
      if (r.height > 0 && r.top <= 1 && r.bottom > 0 && (cs.position === 'sticky' || cs.position === 'fixed')) top = Math.max(top, r.bottom);
    }
    n = document.querySelectorAll(BOTTOM_OVERLAYS);
    for (i = 0; i < n.length; i++) {
      if (el && n[i].contains(el)) continue;
      r = n[i].getBoundingClientRect(); cs = getComputedStyle(n[i]);
      if (cs.display === 'none' || cs.visibility === 'hidden' || r.height <= 0 || r.top >= vh || r.bottom < vh - 4) continue;
      bot = Math.max(bot, vh - r.top);
    }
    return { top: top, bot: bot };
  }

  function shown(el) {
    if (!el || !el.isConnected || el.closest('[hidden]') || el.closest('[data-ab-pending]')) return false;
    var cs = getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && el.getClientRects().length > 0;
  }

  /* Nothing painted on top: the centre and at least 3 of 4 inset corners must hit the element itself or a
     descendant (catches overlays the inset scan misses, e.g. a banner floating a few px above the bottom edge).
     Small fixed widgets (chat launcher, badges; <= 120 x 120 px) do not count as covering. */
  var SMALL = 120;
  function smallWidget(h) {
    for (var n = h; n && n !== document.body && n.nodeType === 1; n = n.parentElement) {
      var p = getComputedStyle(n).position;
      if (p === 'fixed' || p === 'sticky') { var q = n.getBoundingClientRect(); return q.width <= SMALL && q.height <= SMALL; }
    }
    return false;
  }
  function free(el, x, y) {
    var h = document.elementFromPoint(x, y);
    return !!h && (h === el || el.contains(h) || smallWidget(h));
  }
  function clear(el) {
    if (!document.elementFromPoint) return true;
    var r = el.getBoundingClientRect(), dx = Math.min(16, r.width / 4), dy = Math.min(16, r.height / 4);
    if (!free(el, r.left + r.width / 2, r.top + r.height / 2)) return false;
    var n = 0, c = [[r.left + dx, r.top + dy], [r.right - dx, r.top + dy], [r.left + dx, r.bottom - dy], [r.right - dx, r.bottom - dy]];
    for (var i = 0; i < c.length; i++) if (free(el, c[i][0], c[i][1])) n++;
    return n >= 3;
  }

  function inView(el, rect) {
    if (!shown(el)) return false;
    var r = rect || el.getBoundingClientRect(), v = insets(el);
    return r.height > 0 && r.top >= v.top - 2 && r.bottom <= window.innerHeight - v.bot + 2 &&
      r.left >= -2 && r.right <= document.documentElement.clientWidth + 2 && clear(el);
  }

  function boxReady(box) {
    return box.hasAttribute('data-bm-on') && document.visibilityState !== 'hidden' && inView(box, outer(box));
  }

  /* Largest pop scale (<= wanted) that keeps the box inside the buy box (motif inside the viewport) and
     clear of neighbouring text/controls on every side. Scaling origin: 50 % / 55 %. Measured on the rendered text (Range). */
  function fitScale(box, wanted) {
    var b = box.getBoundingClientRect(), u = outer(box);
    var ox = b.left + b.width * 0.5, oy = b.top + b.height * 0.55, gap = 6, s = wanted;
    var cap = function (room, dist) { if (dist > 0.5) s = Math.min(s, room / dist); };
    var scope = box.closest('.buybox') || box.closest('.bcard') || box.closest('.riwi-lp2') || document.body;   /* the visible card */
    var sr = scope.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    cap(ox - Math.max(sr.left, 0) - 1, ox - b.left); cap(Math.min(sr.right, vw) - 1 - ox, b.right - ox);   /* box stays inside the buy box */
    cap(ox, ox - u.left); cap(vw - ox, u.right - ox);                                                     /* motif never leaves the viewport */
    var wide = { left: ox - (ox - u.left) * wanted, right: ox + (u.right - ox) * wanted };
    var all = scope.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var o = all[i], ctl = /^(INPUT|BUTTON|SELECT|IMG|A|LABEL|SVG)$/i.test(o.tagName);
      if (o === box || box.contains(o) || o.contains(box) || o.closest('[aria-hidden="true"]')) continue;
      if (!ctl && ![].some.call(o.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); })) continue;
      if (!shown(o)) continue;
      var q = o.getBoundingClientRect();
      if (!ctl && document.createRange) {
        var rg = document.createRange(); rg.selectNodeContents(o);
        var tq = rg.getBoundingClientRect(); if (tq.width > 0) q = tq;
      }
      if (q.width <= 1 || q.height <= 1) continue;
      if (q.bottom <= u.top + 1) { if (q.right > wide.left && q.left < wide.right) cap(oy - q.bottom - gap, oy - u.top); }
      else if (q.top >= u.bottom - 1) { if (q.right > wide.left && q.left < wide.right) cap(q.top - gap - oy, u.bottom - oy); }
      else if (q.right <= u.left + 1) cap(ox - q.right - gap, ox - u.left);
      else if (q.left >= u.right - 1) cap(q.left - gap - ox, u.right - ox);
    }
    return Math.max(1, Math.min(wanted, s));
  }

  /* Only interaction with the page itself ends the motion. Clicks/keys inside overlays (cookie/consent banner,
     dialogs, chat widgets, preview bar, any other fixed layer except the sticky buy bar) are ignored. */
  var OVERLAY_SEL = '#shopify-pc__banner, #PBarNextFrame, [role="dialog"], [role="alertdialog"], [aria-modal="true"]';
  function onPage(e) {
    var t = e && e.target;
    if (!t || t.nodeType !== 1) return true;
    if (t.closest(OVERLAY_SEL)) return false;
    for (var n = t; n && n !== document.body && n.nodeType === 1; n = n.parentElement) {
      if (n.hasAttribute('data-sticky-atc')) return true;
      if (getComputedStyle(n).position === 'fixed') return false;
    }
    return true;
  }

  function popFrames(peak) {
    return [
      { transform: 'scale(1)', easing: E_OUT, offset: 0 },
      { transform: 'scale(' + peak.toFixed(4) + ')', easing: E_IO, offset: 0.4 },
      { transform: 'scale(.985)', easing: E_IO, offset: 0.72 },
      { transform: 'scale(1)', offset: 1 }
    ];
  }

  function start(box) {
    var DESK = mq(DESKTOP_MQ);
    var anims = [], cleanup = [], timers = [], stopped = false;
    var SHINE_DUR = DESK ? T.SHINE_D : T.SHINE_M;
    var SHINE_AT = T.P1 + T.PAUSE + T.P2 + (DESK ? T.GAP_D : T.GAP_M);
    var later = function (fn, ms) { var id = setTimeout(fn, ms); timers.push(id); return id; };

    function stop() {
      if (stopped) return;
      stopped = true;
      timers.forEach(function (id) { clearTimeout(id); });
      anims.forEach(function (a) { try { a.cancel(); } catch (e) {} });
      cleanup.forEach(function (fn) { try { fn(); } catch (e) {} });
      ['click', 'keydown'].forEach(function (e) { document.removeEventListener(e, onUser, true); });
      document.removeEventListener('visibilitychange', onHide);
      window.removeEventListener('pagehide', stop);
    }
    function onHide() { if (document.hidden) stop(); }
    function onUser(e) { if (onPage(e)) stop(); }
    ['click', 'keydown'].forEach(function (e) { document.addEventListener(e, onUser, { capture: true, passive: true }); });
    document.addEventListener('visibilitychange', onHide);
    window.addEventListener('pagehide', stop);

    markSeen();
    addCss();
    var peak = fitScale(box, SCALE);
    var origin = box.style.transformOrigin;
    box.style.transformOrigin = '50% 55%';
    cleanup.push(function () { box.style.transformOrigin = origin; });
    anims.push(box.animate(popFrames(peak), { duration: T.P1, easing: 'linear', fill: 'none' }));
    anims.push(box.animate(popFrames(1 + (peak - 1) * T.P2_K), { delay: T.P1 + T.PAUSE, duration: T.P2, easing: 'linear', fill: 'forwards' }));

    function targets() {
      var out = [], hero = box.closest('.riwi-lp2') || document;
      var main = hero.querySelector('[data-atc]');
      var bar = document.querySelector('[data-sticky-atc].is-visible:not([hidden]) [data-sticky-btn]');
      [main, bar].forEach(function (b) {
        if (b && !b.disabled && b.getAttribute('aria-disabled') !== 'true' && inView(b) && out.indexOf(b) < 0) out.push(b);
      });
      return out;
    }
    function sweep(btn) {
      var clip = document.createElement('span'), sh = document.createElement('span');
      clip.className = 'rom-shine-clip'; clip.setAttribute('aria-hidden', 'true');
      sh.className = 'rom-shine'; clip.appendChild(sh); btn.appendChild(clip);
      cleanup.push(function () { clip.remove(); });
      var a = sh.animate([
        { transform: 'translateX(-130%) skewX(-20deg)', opacity: 0, easing: E_SHINE, offset: 0 },
        { transform: 'translateX(-60%) skewX(-20deg)', opacity: 1, easing: E_SHINE, offset: 0.15 },
        { transform: 'translateX(290%) skewX(-20deg)', opacity: 1, easing: E_SHINE, offset: 0.85 },
        { transform: 'translateX(360%) skewX(-20deg)', opacity: 0, offset: 1 }
      ], { duration: SHINE_DUR, easing: 'linear', fill: 'none' });
      anims.push(a);
      return a;
    }
    function tryShine() {
      if (stopped) return;
      if (!shown(box)) { stop(); return; }
      var t = targets();
      if (!t.length) { later(tryShine, 250); return; }   /* no buy button visible yet: sweep as soon as one is */
      Promise.all(t.map(function (b) { return sweep(b).finished; })).then(stop, function () {});
    }
    later(function () {
      anims.slice(0, 2).forEach(function (a) { try { a.cancel(); } catch (e) {} });   /* box is back at scale(1) */
      tryShine();
    }, SHINE_AT);
    later(stop, T.FAILSAFE);
  }

  /* Waits until the box is fully visible for DWELL ms without interruption, then starts once. */
  function watch(box) {
    var since = 0, poll = 0, near = false, done = false;
    var reset = function (e) { if (onPage(e)) since = 0; };
    function tick() {
      poll = 0;
      if (done) return;
      if (!box.isConnected) { finish(); return; }
      if (boxReady(box)) {
        if (!since) since = now();
        if (now() - since >= T.DWELL) { finish(); if (!seen()) start(box); return; }
      } else since = 0;
      if (near) poll = setTimeout(tick, T.POLL);
    }
    function finish() {
      done = true; clearTimeout(poll);
      if (io) io.disconnect();
      ['click', 'keydown'].forEach(function (e) { document.removeEventListener(e, reset, true); });
    }
    ['click', 'keydown'].forEach(function (e) { document.addEventListener(e, reset, { capture: true, passive: true }); });
    var io = new IntersectionObserver(function (es) {
      near = es.some(function (e) { return e.isIntersecting; });
      if (near && !poll) tick();
      if (!near) { clearTimeout(poll); poll = 0; since = 0; }
    }, { threshold: [0, 0.5, 1] });
    io.observe(box);
  }

  function init() {
    try {
      if (window.Shopify && window.Shopify.designMode) return;
      if (!window.matchMedia || mq('(prefers-reduced-motion: reduce)')) return;
      if (!('IntersectionObserver' in window) || !document.timeline) return;
      var box = document.querySelector(BOX_SEL);
      if (!box || !box.animate || seen()) return;
      var go = function () { try { watch(box); } catch (e) {} };
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(go, go); else go();
    } catch (e) {}
  }

  /* Start waits for document.fonts.ready (real text metrics for the space check); in WebKit this resolves around window load. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
